<template>
<div class="body_overflow">
  <el-table :data="formatData" :row-style="showRow" v-bind="$attrs" size="mini">
    <el-table-column align="center" v-if="columns.length===0" min-width="150">
      <template #default="scope">
        <span><i class="el-icon-edit"></i></span>
        <span v-if="iconShow(0,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
          <i v-if="!scope.row._expanded" class="el-icon-plus"/>
          <i v-else class="el-icon-minus"/>
        </span>
      </template>
    </el-table-column>
    <el-table-column align="center" v-for="(column, index) in columns" v-else :key="column.value" :label="column.text" :width="column.width"  min-width="100">
      <template #default="scope">
        <span v-if="iconShow(index,scope.row)" class="tree-ctrl" @click="toggleExpanded(scope.$index)">
          <i v-if="!scope.row._expanded" class="el-icon-plus"/>
          <i v-else class="el-icon-minus"/>
        </span>
        <span v-html="scope.row[column.value]"></span>
      </template>
    </el-table-column>
    <el-table-column label="操作" align="center" width="330" class-name="small-padding fixed-width">
      <template #default="scope">
        <el-button type="primary" size="mini" @click="handleCreate(scope.row)" plain>添加子部门</el-button>
        <el-button type="primary" size="mini" @click="handleUpdate(scope.row)" plain>编辑</el-button>
        <el-button v-if="!scope.row.children" size="mini" type="danger" @click="del(scope.row,'deleted')" plain>删除</el-button>
      </template>
    </el-table-column>
    <slot/>
  </el-table>

  <el-dialog destroy-on-close :title="textMap[dialogStatus]" v-model="dialogFormVisible" :close-on-click-modal="false" class="button_bg">
    <el-form ref="dataForm" :rules="rules" :model="temp" label-position="right" label-width="100px">
      <div class="common_dialog_box clearfix">
        <div v-if="dialogStatus == 'create'" class="item_one clearfix">
          <el-form-item label="添加子部门" class="item">
            <el-input v-model="temp.name" placeholder="请输入部门名称" style="width:100%;" size="mini" ></el-input>
          </el-form-item>
          
          <el-form-item label="默认角色" class="item">
            <el-select v-model="temp.defaultRoleId" placeholder="请选择默认角色" size="mini">
              <el-option v-for="item in roleLlist" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div v-else class="item_one clearfix">
          <el-form-item label="部门名称" class="item">
            <el-input v-model="temp.name" placeholder="请输入部门名称" style="width:100%;" size="mini" ></el-input>
          </el-form-item>
          
          <el-form-item label="默认角色" class="item">
            <el-select v-model="temp.defaultRoleId" placeholder="请选择默认角色" size="mini">
              <el-option v-for="item in roleLlist" :key="item.id" :label="item.name" :value="item.id">
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <div class="item_one clearfix">
          <el-form-item label="备注" class="item">
            <el-input v-model="temp.remark"  style="width:100%;" size="mini" ></el-input>
          </el-form-item>
        </div>
      </div>
    </el-form>
    <template #footer>
      <div class="dialog-footer">
        <el-button @click="dialogFormVisible = false" size="mini">取消</el-button>
        <el-button type="primary" @click="dialogStatus==='create'?createData():updateData()" size="mini">确定</el-button>
      </div>
    </template>
  </el-dialog>




</div>
</template>

<script>
/**
  Auth: Lei.j1ang
  Created: 2018/1/19-13:59
*/
import treeToArray from './eval'
// import { base_dept_save, base_dept_delete, sys_role_list } from '@/api/crm'
import { getBaseDepts, saveBaseDept, deleteBaseDept,getSysRoles } from '@/api/sys.js'
export default {
  name: 'TreeTable',
  props: {
    /* eslint-disable */
    data: {
      type: [Array, Object],
      required: true
    },
    columns: {
      type: Array,
      default: () => []
    },
    evalFunc: Function,
    evalArgs: Array,
    expandAll: {
      type: Boolean,
      default: false
    },
  },
   data() {
    return {
      dialogFormVisible: false,
      dialogStatus: '',
      textMap: {
        update: '修改',
        create: '新增'
      },
      roleLlist: [],
      temp: {},
      tempDefaultRoleId: 0,
      rules: [],
    }
  },
  computed: {
    // 格式化数据源
    formatData: function() {
      let tmp
      if (!Array.isArray(this.data)) {
        tmp = [this.data]
      } else {
        tmp = this.data
      }
      const func = this.evalFunc || treeToArray
      // const func = this.evalFunc
      const args = this.evalArgs ? Array.concat([tmp, this.expandAll], this.evalArgs) : [tmp, this.expandAll]
      return func.apply(null, args)
      
    }
  },
  created(){
    this.getList2()
    this.$bus.on("addUpdate", (val) => {
      this.getList2()
    });
    this.$bus.on("personUpdate", () => {
      this.getList2()
    });
  },
  methods: {
    del(e) {
      this.$confirm('确认删除该部门', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteBaseDept({id:e.id*1}).then(res=>{
          this.$emit('getlist')
          this.$store.dispatch("delCachedViewByName", "user-user"); //清除"人员管理"页面缓存
          if(res.data.msg != "success"){
            this.$message.error(res.data.msg);
          }else{
             this.$message({
              type: 'success',
              message: '删除成功'
            });
            
          }
        })
      })
    },
    getList2() {
      this.listLoading = true
      getSysRoles({}).then(res => {
        this.roleLlist = res.data.data.list
        this.roleId = res.data.data.list[0].id
      })
    },
    adddep(e) {
      this.dialogFormVisible = true
    },

    resetTemp() {
      this.temp = {
        name: '',
        parentId: '',
      }
    },
    handleCreate(row) {
      this.resetTemp()
      this.temp.parentId = row.id
      this.dialogStatus = 'create'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    createData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          this.temp.id = this.temp.id * 1
          saveBaseDept(this.temp).then((res) => {
            this.$store.dispatch("delCachedViewByName", "user-user"); //清除"人员管理"页面缓存
            if(res.data.msg != "success"){
              return
            }
            // this.list.push(this.temp)
            this.dialogFormVisible = false
              this.$message({
                type: 'success',
                message: '创建成功'
              });
            this.$emit('getlist')
          })
        }
      })
    },
    handleUpdate(row) {
      this.temp = Object.assign({}, row) // copy obj
      this.temp.name = this.temp.label
      this.dialogStatus = 'update'
      this.dialogFormVisible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].clearValidate()
      })
    },
    updateData() {
      this.$refs['dataForm'].validate((valid) => {
        if (valid) {
          const tempData = Object.assign({}, this.temp)
          delete tempData.children;
          delete tempData.parent
          saveBaseDept(tempData).then((res) => {
            this.$store.dispatch("delCachedViewByName", "user-user"); //清除"人员管理"页面缓存
            if(res.data.msg != "success"){
              return
            }
            this.dialogFormVisible = false
             this.$message({
              type: 'success',
              message: '修改成功'
            });
            this.$emit('getlist')
          })
        }
      })
    },
    showRow: function(row) {
      const show = (row.row.parent ? (row.row.parent._expanded && row.row.parent._show) : true)
      row.row._show = show
      return show ? 'animation:treeTableShow 1s;-webkit-animation:treeTableShow 1s;' : 'display:none;'
    },
    // 切换下级是否展开
    toggleExpanded: function(trIndex) {
      const record = this.formatData[trIndex]
      record._expanded = !record._expanded
    },
    // 图标显示
    iconShow(index, record) {
      return (index === 0 && record.children && record.children.length > 0)
    }
  }
}
</script>
<style rel="stylesheet/css">
  @keyframes treeTableShow {
    from {opacity: 0;}
    to {opacity: 1;}
  }
  @-webkit-keyframes treeTableShow {
    from {opacity: 0;}
    to {opacity: 1;}
  }
</style>
<style>
.body_overflow .el-table__body-wrapper{
  overflow: auto !important;
}
</style>
<style lang="scss" rel="stylesheet/scss" scoped>
  $color-blue: #2196F3;
  $space-width: 18px;
  .ms-tree-space {
    position: relative;
    top: 1px;
    display: inline-block;
    font-style: normal;
    font-weight: 400;
    line-height: 1;
    width: $space-width;
    height: 14px;
    &::before {
      content: ""
    }
  }
  .processContainer{
    width: 100%;
    height: 100%;
  }
  table td {
    line-height: 26px;
  }

  .tree-ctrl{
    position: relative;
    cursor: pointer;
    color: $color-blue;
    margin-left: -$space-width;
  }
</style>
